const userDefault = {
	loggedIn: false,
	hasCredits: false,
	credits: 0,
  hasUnlimitedFreeAdsPack: false,
  vblDetails: [],
  companyDetails: {},
  loaded: false,
  whatsappConnectCredits: 0
};

const userReducer = (state = userDefault, actions) => {

	switch (actions.type) {
		case 'UPDATE_USER':
			state = Object.assign({}, state, actions.payload, { loaded: true });
			break;
		default:
			return state;
	}
	return state;
};

export default userReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/UserReducer/index.js